import React from 'react';

import {FilterInput} from 'src/components/input/filter-input';

import Group from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';

type Props = {
    searchQuery: string,
    setSavedSearchQuery?: (value: string) => void,
    setSharedSearchQuery?: (value: string) => void,
    typeLabel: string,
    setCurrentPage: (page: number) => void,
    sectionLabel?: string,
};

export const SearchPanel = ({
    searchQuery,
    setSavedSearchQuery,
    setSharedSearchQuery,
    typeLabel,
    setCurrentPage,
    sectionLabel = 'Saved',
}: Props) => {

    const handleChange = (value: string) => {
        setCurrentPage(1);
        if (setSavedSearchQuery) {
            setSavedSearchQuery(value);
        } else if (setSharedSearchQuery) {
            setSharedSearchQuery(value);
        }
    };

    const handleClear = () =>
        setSavedSearchQuery ? setSavedSearchQuery('') : setSharedSearchQuery?.('');

    const humanTypeRaw = typeLabel || 'item';
    const humanType = humanTypeRaw[0] ? humanTypeRaw[0].toUpperCase() + humanTypeRaw.slice(1) : humanTypeRaw;
    const needsEs = /(ch|sh|s|x|z)$/i.test(humanType.toString());
    const pluralTypeRaw = needsEs ? pluralize(`${humanType}[es]`, 2) : pluralize(`${humanType}[s]`, 2);
    const pluralType = pluralTypeRaw[0].toUpperCase() + pluralTypeRaw.slice(1);

    return (
        <Group>
            <FilterInput
                id="search-panel-filter"
                value={searchQuery}
                onChange={handleChange}
                onClear={handleClear}
                timeOut={300}
                width={345}
                placeholder={`Search for ${sectionLabel} ${pluralType} by name`}
            />
        </Group>
    );
};
